export enum WebhooksQueryKeys {
  WebhooksList = 'webhooks/list',
  WebhookDetails = 'webhooks/details',
  WebhookHistory = 'webhooks/history',
  WebhookCreate = 'webhooks/create',
  WebhookUpdate = 'webhooks/update',
  WebhookDelete = 'webhooks/delete',
}
